var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductAvatar3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 143,
    viewBox: "0 0 196 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 142,
    rx: 6.85714,
    fill: "#75CE9A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_482_3846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.611 104.923L69.2566 104.86C65.9461 104.847 63.2689 102.16 63.2518 98.8752L63.2615 44.0758C63.2704 40.7693 65.9579 38.0981 69.2463 38.0847L126.6 38.1479C129.911 38.1605 132.588 40.8478 132.605 44.1325L132.596 98.9318C132.587 102.238 129.899 104.909 126.611 104.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2581 104.439L126.609 104.502C126.609 104.502 126.61 104.502 126.61 104.502C129.667 104.489 132.166 102.005 132.174 98.9305L132.184 44.1346C132.184 44.1342 132.184 44.1338 132.184 44.1334C132.168 41.0799 129.678 38.5808 126.6 38.5685L69.2581 104.439ZM69.2581 104.439C69.2578 104.439 69.2574 104.439 69.257 104.439C66.1792 104.427 63.6895 101.928 63.6729 98.8743C63.6729 98.8739 63.6729 98.8735 63.6729 98.8731L63.6826 44.0771C63.6826 44.0769 63.6826 44.0768 63.6826 44.0767C63.6911 41.0023 66.1902 38.5184 69.2471 38.5053C69.2474 38.5053 69.2478 38.5053 69.2481 38.5053L126.599 38.5685L69.2581 104.439Z",
    stroke: "#C5C5C5",
    strokeWidth: 0.84173
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.45 96.7162L73.031 96.6804C71.6048 96.6813 70.4663 95.5476 70.4638 94.1231L70.4567 48.8339C70.4542 47.4094 71.588 46.2734 73.0142 46.2726L123.433 46.3083C124.86 46.3074 125.998 47.4411 126.001 48.8657L126.008 94.1548C126.01 95.5793 124.876 96.7153 123.45 96.7162Z",
    fill: "#D1EFDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0405 64.477C91.5049 63.2401 91.6869 61.0505 90.4469 59.5864C89.2069 58.1223 87.0145 57.9381 85.5501 59.175C84.0856 60.4118 83.9036 62.6015 85.1436 64.0656C86.3836 65.5297 88.576 65.7139 90.0405 64.477Z",
    fill: "#75CE9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1442 79.5056L80.9504 79.4844L85.4982 74.3585L87.7721 71.7955L90.046 69.2325L92.3205 71.8008L94.5951 74.3691L99.1442 79.5056Z",
    fill: "#AD91F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0246 70.3293L90.5472 70.0506L90.274 70.2982L89.6401 70.1035L89.0747 70.3271L89.5621 69.7777L89.8058 69.503L90.0495 69.2283L90.2933 69.5036L90.5371 69.7788L91.0246 70.3293Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.466 79.5349L87.9518 79.504L94.5792 72.034L97.8929 68.2989L101.207 64.5639L104.521 68.3066L107.836 72.0494L114.466 79.5349Z",
    fill: "#C8B5F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.632 66.1699L101.936 65.7637L101.538 66.1246L100.614 65.8407L99.7902 66.1666L100.501 65.366L100.856 64.9657L101.211 64.5654L101.566 64.9665L101.921 65.3676L102.632 66.1699Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_482_3846",
    x: 45.4617,
    y: 29.185,
    width: 104.934,
    height: 102.418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.895
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_482_3846"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_482_3846",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAvatar3);
export default __webpack_public_path__ + "static/media/productAvatar3.9996b9ee2123059750e3f7d16c1c3969.svg";
export { ForwardRef as ReactComponent };